import React from 'react';
import Config from 'Config';
import ReactGA from 'react-ga';
import { render } from 'react-dom';
import { Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import BlueprintApp from 'components/BlueprintApp.jsx';
import { requireAuth } from 'components/Pages/BlueprintAuth/BlueprintAuth.jsx';
import BlueprintTheme from 'blueprint/js/BlueprintTheme';
import { ConnectedRouter } from 'connected-react-router';
import GlobalStyle from '@bit/knotchinc.web-react-components.global-style';
import { auth0Redirect } from 'helpers/Routing.js';
import store, { history } from './store';

// https://github.com/react-ga/react-ga/issues/107
// Assuming you're writing a single page application, you don't need to initialize it again
// as it has been initialized upon the bootstrapping of the application (index.js as you mentioned).
if (Config.gAnalytics.enabled) {
  ReactGA.initialize(Config.gAnalytics.code);
}


const provider = (
  <ThemeProvider theme={BlueprintTheme}>
    <GlobalStyle />
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/blueprint/login" component={() => auth0Redirect('/auth/auth0')} />
          <Route exact path="/blueprint/logout" component={() => auth0Redirect('/auth/logout')} />
          <Route path="/blueprint" component={requireAuth(BlueprintApp).connected} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>
);

render(provider, document.getElementById('bodyContainer'));
